"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

require("../../styles/styles.scss");

// Import styles for icons in styleguide

/**
 * MuiIcon is used in storyblok redirect to react routes
 */
var MuiIcon = function MuiIcon(_ref) {
  var color = _ref.color,
      fontSize = _ref.fontSize,
      iconName = _ref.iconName;
  return /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: color,
    fontSize: fontSize
  }, iconName);
};

exports.MuiIcon = MuiIcon;
var _default = MuiIcon;
exports.default = _default;
MuiIcon.propTypes = {
  /**
      * any icon from [material.io](https://material.io/resources/icons/?style=baseline)
      * ex star | alarm_off
      * */
  iconName: _propTypes.default.string.isRequired,

  /**
   * mui prop: "inherit", "primary", "secondary", "action", "error", "disabled"
   * The color of the component. It supports those theme colors that make sense for this component.
   * */
  color: _propTypes.default.string,

  /**
   * mui prop: 'default' | 'small'| 'inherit'| 'large'
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * */
  fontSize: _propTypes.default.string
};
MuiIcon.defaultProps = {
  color: 'secondary',
  fontSize: 'default'
};